import React from 'react';
import { View, StyleSheet } from 'react-native';
import { Card, Text } from 'react-native-elements';

interface Props {
  country: string;
  company: string;
  address: string;
  location: string;
  postalCode: string;
}

const MessageCard: React.FC<Props> = ({
  country,
  company,
  address,
  location,
  postalCode,
}: Props) => {
  return (
    <View style={styles.card}>
      <Card containerStyle={styles.cardContainer}>
        <Card.Title style={styles.title}>{country}</Card.Title>
        <Text style={styles.body}>{company}</Text>
        <Text style={styles.body}>{address}</Text>
        <Text style={styles.body}>{location}</Text>
        <Text style={styles.body}>{postalCode}</Text>
      </Card>
    </View>
  );
};

const styles = StyleSheet.create({
  card: {
    flex: 1,
    backgroundColor: '#f7f7f7',
  },
  cardContainer: {
    borderWidth: 0,
    paddingHorizontal: 15,
    marginHorizontal: 0,
  },
  title: {
    textAlign: 'left',
    color: '#303133',
    fontSize: 20,
    fontWeight: 'bold',
  },
  body: {
    color: '#777777',
  },
});

export default MessageCard;
